import * as bootstrap from 'bootstrap';

// Bootstrap 5 modal helpers (replacing the old jQuery `$('#x').modal(...)` plugin calls).

export const showModal = (id, options = {}) => {
  const el = document.getElementById(id);
  if (el) bootstrap.Modal.getOrCreateInstance(el, options).show();
};

export const hideModal = (id) => {
  const el = document.getElementById(id);
  if (el) bootstrap.Modal.getOrCreateInstance(el).hide();
};

// The loading overlay is shown/hidden from many sites — dedicated helpers keep those calls terse.
const LOADING_OPTIONS = { backdrop: 'static', keyboard: false };
export const showLoading = () => showModal('loadingBox', LOADING_OPTIONS);
export const hideLoading = () => hideModal('loadingBox');
